import React from "react";

const ImportContext = React.createContext();

export default ImportContext;